import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {ExpertPaymentService} from '@services/expert-payment.service';
import {UserStateService} from '@services/frontend/user-state.service';
import {Role} from '@models/user.interface';

/** Bloque l'accès à l'espace expert si le paiement unique n'a pas été effectué. */
export const expertPaymentGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userState = inject(UserStateService);
  const expertPaymentService = inject(ExpertPaymentService);
  const user = userState.getUser()();

  if (user?.role === Role.ADMIN) {
    return true;
  }
  if (user?.role !== Role.ACCOUNTANT) {
    return true;
  }

  return expertPaymentService.checkExpertPayment().pipe(
    map((status) =>
      status.paid
        ? true
        : router.createUrlTree(['/dashboard', 'expert', 'paiement'])
    )
  );
};

/** Redirige vers le tableau de bord si le paiement est déjà effectué. */
export const expertPaymentPageGuard: CanActivateFn = () => {
  const router = inject(Router);
  const expertPaymentService = inject(ExpertPaymentService);

  return expertPaymentService.checkExpertPayment().pipe(
    map((status) =>
      status.paid
        ? router.createUrlTree(['/dashboard', 'expert', 'clients'])
        : true
    )
  );
};
